import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import {
  fromElementToStr,
  fromStrToElement
} from '../../../scripts/components/moderation-v2/comments-and-posts/utils/domUtils';

const BASE_ICON_URL = 'https://admin.spot.im/icons';

interface IconProps {
  name: string;
  className?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: () => void;
}

const Icon: React.FC<IconProps> = ({
  name,
  className,
  onMouseEnter,
  onMouseLeave,
  onClick,
  ...restProps
}) => {
  const [svgXml, setSvgXml] = useState<string | null>(null);

  useEffect(() => {
    const url = `${BASE_ICON_URL}/${name}.svg`;
    fetch(url)
      .then(res => {
        if (res.ok) {
          return res.text();
        }
        return Promise.reject();
      })
      .then(xml => {
        // Workaround for removing height and width attributes to align behaviour with the old expectation from
        // svg-inline-loader that automatically removed it.
        const svg = fromStrToElement(xml);

        svg?.removeAttribute('height');
        svg?.removeAttribute('width');

        const cleansedXml = fromElementToStr(svg);

        setSvgXml(cleansedXml);
      })
      .catch(() => {
        setSvgXml(null);
      });
  }, [name]);

  return (
    <svg
      dangerouslySetInnerHTML={{ __html: svgXml }}
      className={classnames('icon', className)}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...restProps}
    />
  );
};

export default Icon;
